import { loadPageScript } from "./routes.js";
import { ZAccordionService } from "./services/accordion.js";
import { ZApiService } from "./services/api_service.js";
import { ZLoadingService } from "./services/loading.js";
import { MODAL_TYPE, ModalService } from "./services/modal_service.js";
import { enableTooltips, hideSidePanel, initBottomNav, initContactForm, initDisabledMenuItems, initMobileSidePanel, initQueryFilters, initSubscriptions, updateMobile, updateRelativeTime, waitForFirstUserCrawl } from "./utils.js";
Object.assign(globalThis, {
    api: new ZApiService(),
    modalService: new ModalService(),
    Loading: new ZLoadingService(),
    accordionService: new ZAccordionService(),
    charts: {},
});
updateMobile();
loadPageScript();
$(() => {
    console.log('Initialized Global Script...');
    if (updateRelativeTime() > 0) {
        setInterval(() => updateRelativeTime(), 1000);
    }
    enableTooltips();
    $(window).on('resize', () => {
        var _a, _b, _c;
        for (let id in ((_a = globalThis.Chart) === null || _a === void 0 ? void 0 : _a.instances) || []) {
            (_c = (_b = globalThis.Chart) === null || _b === void 0 ? void 0 : _b.instances[id]) === null || _c === void 0 ? void 0 : _c.resize();
        }
        updateMobile();
    });
    updateMobile();
    initMobileSidePanel();
    initQueryFilters();
    initSubscriptions();
    initDisabledMenuItems();
    initContactForm();
    initBottomNav();
    accordionService.initHandlers($('body'));
    const $firstUserCrawl = $('[key="firstUserCrawl"]');
    if ($firstUserCrawl.length && $firstUserCrawl.attr('value') !== '1') {
        const events = modalService.create({
            title: 'Welkom!',
            content: (`
				Ons systeem moet uw gegevens nog ophalen!
				Klik op Oké om verder te gaan!
			`),
            type: MODAL_TYPE.OK
        });
        events.onClose(() => { });
        waitForFirstUserCrawl().catch(err => {
            modalService.error(err);
            console.error(err);
        });
    }
    const $links = $('.header-link a,.side-panel a.list-group-item');
    $links.on('click', (e) => {
        $links.removeClass('selected');
        // console.log($(e.target))
        $(e.target).addClass('selected');
    });
    if ($('.header-link a.selected').length === 0) {
        $('.header-link a[href="/"]').addClass('selected');
    }
    $(window).on('hashchange', (e) => {
        const hash = location.hash.split('?')[0];
        const $link = $(`a[href="/${hash}"]`);
        if ($link.length) {
            $links.removeClass('selected');
            $link.addClass('selected');
        }
    });
    if (location.hash.startsWith('#')) {
        // scrollSmoothlyToBottom(location.hash.split('?')[0])
        $(window).trigger('hashchange');
    }
    $('.side-panel a[href]').on('click', (e) => {
        hideSidePanel();
    });
});
//# sourceMappingURL=index.js.map